import React, { CSSProperties } from 'react';
import { useTheme } from '../../../../../hooks/useTheme';
import { outlinedStar, filledStar } from './paths';
import styles from './Star.module.css';

export interface StarIconProps {
  full?: boolean;
  s?: CSSProperties;
  'data-test'?: string | null;
}

const StarIcon = ({
  full = false,
  s = {},
  'data-test': dataTest = null,
}: StarIconProps) => {
  const { iconsPrimaryNone: starIconStyle } = useTheme();
  const style = { ...starIconStyle, ...s };

  return (
    <svg
      role="img"
      className={styles.container}
      style={{ fill: style.color, ...style }}
      viewBox="0 0 32 32"
      data-test={dataTest}
    >
      <path d={full ? filledStar : outlinedStar} />
    </svg>
  );
};

export default StarIcon;
